import { buildMiddleware, ServerConnection } from '@paragon/data-connections';

import { normalizeObject } from './dataNormalization';

const dataNormalizationMiddleware = buildMiddleware(normalizeObject);

export const AuthorizationApi = new ServerConnection('authorizationApiUrl', dataNormalizationMiddleware);
export const SealingService = new ServerConnection('sealingServerApiUrl', dataNormalizationMiddleware);
